import React from 'react';
import { InlineStack } from './TechStack';
export interface CondensedRole {
  company: string;
  role: string;
  period: string;
  note?: string;
  stack?: string[];
}
/**
 * Condensed roles listed as tight rows so the full career timeline is present
 * without competing with the detailed senior roles. Used for both demoted
 * mid-career roles and the earliest ones.
 */
export function EarlierExperience({
  roles
}: {
  roles: CondensedRole[];
}) {
  if (roles.length === 0) return null;
  return <ul className="divide-y divide-[var(--line)]" data-id="element-98" data-mp="1z642y6iavv7l">
      {roles.map((r, i) => <li key={i} className="cv-entry grid grid-cols-[118px_1fr] gap-5 py-2.5 first:pt-0" data-id="element-99" data-mp="2dugzb4lavg2m" data-mpi={i}>
          <span className="whitespace-nowrap pt-[3px] text-right font-mono text-[9px] tabular-nums leading-snug text-[var(--ink-faint)]" data-id="element-100" data-mp="28uuf2b720zkb">
            {r.period}
          </span>
          <div className="min-w-0" data-id="element-101" data-mp="2itjs9qo09vu8">
            <p className="flex flex-wrap items-baseline gap-x-2" data-id="element-102" data-mp="2iul6g40biyg6">
              <span className="font-display text-[14px] font-medium leading-tight text-[var(--ink)]" data-id="element-103" data-mp="1vza4x7g3ouk5">
                {r.company}
              </span>
              <span className="text-[11px] uppercase tracking-[0.08em] text-[var(--accent)]" data-id="element-104" data-mp="2013zcxzpd2bv">
                {r.role}
              </span>
            </p>
            {r.note && <p className="mt-0.5 text-[11.5px] leading-relaxed text-[var(--ink-soft)]" data-id="element-105" data-mp="29ztbsb8txukq">
                {r.note}
              </p>}
            {r.stack && r.stack.length > 0 && <InlineStack stack={r.stack} data-id="element-106" data-mp="2iyof9fkhoqkc" />}
          </div>
        </li>)}
    </ul>;
}